import { isCurrentView } from "../../../shared/utils/view-util";
import { initializeBusinessTypesAndChangeDetection } from "../../../shared/utils/business-overview-util";

document.addEventListener("DOMContentLoaded", function () {
  if (!isCurrentView(".signup.business_activity")) {
    return;
  }

  const form = "business_activity_form";
  const businessSectionSelect = $(`#${form}_merchant_industry_section`);
  const businessIndustrySelect = $(`#${form}_merchant_industry`);
  const persistedSectionValue = $(
    `#${form}_persisted_merchant_industry_section`,
  ).val();
  const persistedIndustryValue = $(
    `#${form}_persisted_merchant_industry`,
  ).val();
  const sectionCallback = $.Deferred();

  initializeBusinessTypesAndChangeDetection(
    form,
    businessSectionSelect,
    businessIndustrySelect,
    persistedSectionValue,
    persistedIndustryValue,
    sectionCallback,
  );
});
